'use client';

import Dashboard from "@/pages/Dashboard"

export default function Home() {
  // Check if we're in a browser environment
  const isBrowser = typeof window !== 'undefined';
  
  if (!isBrowser) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
              <div className="text-center">
        <div className="flex justify-center mb-4">
          <img
                    src="/assets/images/saarthiq_logo_white_bg.png"
        alt="SaarthiQ Logo" 
            className="h-20 w-auto"
          />
        </div>
        <h1 className="text-2xl font-bold text-foreground mb-4">
          SaarthiQ
        </h1>
        <p className="text-muted-foreground">
          Loading application...
        </p>
      </div>
      </div>
    );
  }

  return <Dashboard />
} 